import React from 'react';
import { Button, Card, CardContent, IconButton } from "@mui/material";
import { Delete, Pin, Plus } from "lucide-react";

const NotesPage = ({ notes, toggleTopNote, deleteNote, setDialogs }) => {
    return (
        <div className="max-w-6xl mx-auto space-y-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <p className="text-xs uppercase tracking-[0.22em] text-teal-300/80">Память</p>
                    <h2 className="panel-title mt-2 text-3xl font-bold">Заметки</h2>
                </div>
                <Button
                    variant="contained"
                    startIcon={<Plus />}
                    onClick={() => setDialogs(prev => ({ ...prev, note: true }))}
                    sx={{ minHeight: 46 }}
                >
                    Добавить заметку
                </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {notes.map(note => (
                    <Card key={note.id} elevation={0} className={note.isTop ? 'ring-1 ring-teal-300/60' : ''}>
                        <CardContent>
                            <div className="flex justify-between gap-3">
                                <div className="min-w-0 flex-1">
                                    <p className="break-words text-lg font-medium text-white">{note.text}</p>
                                    <p className="muted-label mt-3 text-sm">
                                        {new Date(note.date).toLocaleDateString('ru-RU')}
                                    </p>
                                    {note.reminder && (
                                        <p className="mt-1 text-sm text-teal-300">
                                            Напоминание: {new Date(note.reminder).toLocaleString('ru-RU')}
                                        </p>
                                    )}
                                </div>
                                <div className="flex shrink-0 flex-col gap-2">
                                    <IconButton
                                        size="small"
                                        onClick={() => toggleTopNote(note.id)}
                                        sx={{ color: note.isTop ? '#2dd4bf' : '#94a3b8' }}
                                    >
                                        <Pin size={18} />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={() => deleteNote(note.id)}
                                        sx={{ color: '#fb7185' }}
                                    >
                                        <Delete size={18} />
                                    </IconButton>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default NotesPage;
